<template>
  <span class="button-checkbox">
    <button type="button" class="btn btn-xs btn-default" :class="{'active': titleObj.actionCode === action}" @click="toggleCheckbox()" :disabled="disabled">
      <span :class="[titleObj.actionCode === 'N' ? 'glyphicons glyphicons-unchecked' : 'glyphicons glyphicons-check']"></span> {{buttonLabel}}</button>
  </span>
</template>

<script>
  export default {
    name: 'button-checkbox',
    props: ['title', 'action', 'disabled'],
    data () {
      return {
        titleObj: this.title
      }
    },
    computed: {
      buttonLabel () {
        return this.titleObj.memberTitle.description + (this.titleObj.memberSport ? ' - ' + this.titleObj.memberSport.description : '')
      }
    },
    methods: {
      toggleCheckbox () {
        this.titleObj.actionCode = this.titleObj.actionCode === 'N' ? this.action : 'N'
        this.$emit('toggle-title', this.titleObj)
      }
    }
  }
</script>
